import React from 'react';
import * as Dto from "actions/Dto"

export default function UserAvatar(props: {user: Dto.UserDto}) {
	return (
		<img className="profile-photo" src={props.user && props.user.photoUrl != null && props.user.photoUrl.length > 0 ? props.user.photoUrl : "/media/user@4x.png"} alt="User"/>
	);
}
